import { TableClass } from '../../../world/spa/libs/classes';

export default {
	payCheckoutMethod() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'card',
				it: "Carta",
				en: "Card"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'paypal',
				it: "Paypal",
				en: "Paypal"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'satispay',
				it: "Satispay",
				en: "Satispay"
			}
		});
	},
	worldAdminDocumentType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'invoice',
				it: "Fattura",
				en: "Invoice"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'transport',
				it: "Documento di trasporto",
				en: "Transport document"
			}
		});
	},
	processingSystem() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'none',
				it: "Nessuna",
				en: "None"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'visa',
				it: "Visa",
				en: "Visa"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'mastercard',
				it: "Mastercard",
				en: "Mastercard"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'americanExpress',
				it: "American Express",
				en: "American Express"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'discover',
				it: "Discover",
				en: "Discover"
			},
			6: {
				typeClass: 6,
				typeClassLiteral: 'maestro',
				it: "Maestro",
				en: "Maestro"
			},
			7: {
				typeClass: 7,
				typeClassLiteral: 'pagoBancomat',
				it: "PagoBancomat",
				en: "PagoBancomat"
			},
			8: {
				typeClass: 8,
				typeClassLiteral: 'dinersClub',
				it: "Diners Club",
				en: "Diners Club"
			},
			9: {
				typeClass: 9,
				typeClassLiteral: 'chinaUnionPay',
				it: "China UnionPay",
				en: "China UnionPay"
			},
			10: {
				typeClass: 10,
				typeClassLiteral: 'entrustBankcard',
				it: "Entrust Bankcard",
				en: "Entrust Bankcard"
			},
			11: {
				typeClass: 11,
				typeClassLiteral: 'japanCreditBureau',
				it: "Japan Credit Bureau",
				en: "Japan Credit Bureau"
			},
			12: {
				typeClass: 12,
				typeClassLiteral: 'solo',
				it: "Solo",
				en: "Solo"
			},
			13: {
				typeClass: 13,
				typeClassLiteral: 'interac',
				it: "Interac",
				en: "Interac"
			},
			14: {
				typeClass: 14,
				typeClassLiteral: 'cB',
				it: "CB",
				en: "CB"
			}
		});
	},
	cardType() {
		return new TableClass({
			1: {
				typeClass: 1,
				typeClassLiteral: 'credit',
				it: "Carta di credito",
				en: "Credit card"
			},
			2: {
				typeClass: 2,
				typeClassLiteral: 'debit',
				it: "Carta di debito",
				en: "Debit card"
			},
			3: {
				typeClass: 3,
				typeClassLiteral: 'prepaid',
				it: "Carta prepagata",
				en: "Prepaid card"
			},
			4: {
				typeClass: 4,
				typeClassLiteral: 'storedValue',
				it: "Gift card",
				en: "Store-value card"
			},
			5: {
				typeClass: 5,
				typeClassLiteral: 'loyaltyCard',
				it: "Carta fedeltà",
				en: "Loyalty card"
			}
		});
	}
}
